import axios from 'axios';
import config from 'api/urls-config.json';

export const getInformationMaterials = params => {
    return axios.get(`${config.API + config.pages.information_materials}`, { params });
};
